import { Stack, Tooltip, tooltipClasses, Link } from "@mui/material";
import { TOOLTIP_DELAY } from "@utils";
import palette from "src/theme/palette";
import React, { useState } from "react";
import typography from "src/theme/typography";

const EMPTY_OBJ = {};

const getVariantStyles = (variant) => {
  const variants = {
    dark: {
      backgroundColor: palette.system[700],
      color: palette.system[0]
    },
    light: {
      backgroundColor: palette.system[0],
      color: palette.text[800],
      padding: "16px",
      ...typography.body2
    }
  };
  return variants[variant] || variants.dark;
};

const CustomTooltip = ({
  title,
  placement = "top",
  children,
  open: controlledOpen,
  popperStyle = EMPTY_OBJ,
  tooltipStyle = EMPTY_OBJ,
  stackStyle = EMPTY_OBJ,
  component,
  testId,
  enterDelay = TOOLTIP_DELAY.SHORT,
  enterNextDelay = TOOLTIP_DELAY.NONE,
  disablePortal = false,
  variant = "dark",
  onClose,
  onOpen,
  disableInteractive
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const handleOpen = () => {
    if (!isControlled) {
      setInternalOpen(true);
    }
    onOpen?.();
  };

  const handleClose = () => {
    if (!isControlled) {
      setInternalOpen(false);
    }
    onClose?.();
  };

  return (
    <Tooltip
      title={title}
      placement={placement}
      open={open}
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      leaveDelay={100}
      onClose={handleClose}
      onOpen={handleOpen}
      disableInteractive={disableInteractive}
      slotProps={{
        tooltip: {
          "data-testid": testId ? `${testId}-tooltip` : undefined,
          sx: (theme) => ({
            ...tooltipStyle,
            ...getVariantStyles(variant),
            boxShadow: theme.shadows[4],
            borderRadius: "8px"
          })
        },
        popper: {
          disablePortal,
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*=top] .${tooltipClasses.tooltip}`]: {
              marginBottom: "4px",
              ...popperStyle
            },
            [`&.${tooltipClasses.popper}[data-popper-placement*=bottom] .${tooltipClasses.tooltip}`]: {
              marginTop: "4px",
              ...popperStyle
            },
          }
        }
      }}>
      <Stack
        {...(component && { component })}
        alignItems={"center"}
        direction={"row"}
        sx={{ ...stackStyle }}
      >
        {children}
      </Stack>
    </Tooltip>
  );
};

export default CustomTooltip;
